import { hasGraphqlError, useMutation } from 'Data/Api.js'
import { useDataChange, useDataValue } from 'Simple/Data.js'
import { notifyError, useNotifications } from 'Logic/Notifications.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

import mutation from './mutation.graphql.js'
import { CHECKIN_ERROR_CODES } from '../../useDataOnSubmit.js'

export function useOnClick(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  let appointment_booking_id = useDataValue({
    context: 'check_in',
    path: 'appointment_booking._id',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'check_in',
    viewPath: props.viewPath,
  })

  let [, executeMutation] = useMutation(mutation)
  let [, notify] = useNotifications()

  return async function onClick() {
    // check settings (patient is late or has billing overdue)
    change(next => {
      next.disabled = true
    })
    let mutationResponse = await executeMutation({
      id: appointment_booking_id,
    })

    if (
      hasGraphqlError(
        mutationResponse,
        CHECKIN_ERROR_CODES.CANNOT_RESOLVE_PATIENT_CONNECTION
      )
    ) {
      change(next => {
        next.failed_app_id =
          mutationResponse.error.graphQLErrors[0].extensions.app_id
        next.failed_app_name =
          mutationResponse.error.graphQLErrors[0].extensions.app_name
        next.disabled = false
      })

      setFlowTo(normalizePath(props.viewPath, '../../AssignConnection/Content'))
      return
    }

    if (mutationResponse.error) {
      notify(
        notifyError('Cannot check in selected appointment. Please try again.')
      )
      change(next => {
        next.disabled = false
      })
    }
  }
}
